/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Preferred_VoiceInputs */

const en_settings_v2_preferred_voice = /** @type {(inputs: Settings_V2_Preferred_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred voice`)
};

const es_settings_v2_preferred_voice = /** @type {(inputs: Settings_V2_Preferred_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz preferida`)
};

/**
* | output |
* | --- |
* | "Preferred voice" |
*
* @param {Settings_V2_Preferred_VoiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_preferred_voice = /** @type {((inputs?: Settings_V2_Preferred_VoiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Preferred_VoiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_preferred_voice(inputs)
	return en_settings_v2_preferred_voice(inputs)
});